import React from "react";
import '../styles/QuestionsList.css';
import { Rate } from "antd";
import TextArea from "antd/es/input/TextArea";

const QuestionList = (props) => {
    const onChange = (item, value, type) => {
        const updatedQuestions = props.questions.map(q => {
            if (q.id === item.id) {
                return {
                    ...q,
                    rating: type === 'rating' ? value : q.rating,
                    remarks: type === 'rating' && value > 2 ? "" : (type === 'remarks' ? value : q.remarks)
                };
            }
            return q;
        });
    
        props.setRating(updatedQuestions);
    };
    
    return (
        <div className="questions-list">
            {
                props.questions.map((item,index) =>
                    <div className="question-item" key={index}>
                        <div className="question">{index + 1} . {item.question}</div>
                        <div className="rating-container">
                            <Rate defaultValue={0} value={item.rating} onChange={(value) => { onChange(item, value, 'rating') }} />
                            {item.rating && item.rating <= 2 ?
                                <div className="rating-remarks">
                                    <div className="remarks-title">
                                        Please specify a reason for the low rating
                                    </div>
                                    <TextArea value={item.remarks} onChange={(e) => onChange(item, e.target.value, 'remarks')} placeholder="Please specify a reason"
                                        autoSize={{ minRows: 3, maxRows: 5 }} />
                                </div> :
                                <></>
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}
export default QuestionList;